import {
  BillStatus,
  getAuthSession,
  INITIATED,
  InternalBillType,
  isEmpty,
  isNumberEmpty,
  OfferType,
  PayMedium,
  printDebugLog,
  SEND_TO_KITCHEN
} from "../../../constants/constant";
import uiUtilInstance from "../../../utilities/uiUtil";
import { calculateRestoConversionPrice, getRestoConversionSnapshot } from "../restoBillingConversion";

export const getFinalPrice = (mPrice, offerAmt, offerDenom, quantity) => {
    let sPrice = 0.0;
    if (offerDenom === OfferType.Flat) {
        sPrice = mPrice - offerAmt;
    } else if (offerDenom === OfferType.Percentage) {
        sPrice = mPrice
            - ((mPrice * offerAmt) / 100);
    } else {
        sPrice = mPrice;
    }
    sPrice = quantity * sPrice;
    return sPrice;
};

export const buildItems = (cellData, quantity) => {
    const conversionSnapshot = getRestoConversionSnapshot(cellData);
    const conversionPrice = calculateRestoConversionPrice({ ...cellData, ...conversionSnapshot,
        offerDenom: cellData.offertype, offerAmt: cellData.offerAmt }, quantity,
        conversionSnapshot.selectedUnit);
    const billObj = {};
    billObj.cgst = cellData.cgst;
    billObj.prdId = cellData.id;
    billObj.name = cellData.name;
    billObj.sgst = cellData.sgst;
    Object.assign(billObj, conversionSnapshot, conversionPrice);
    billObj.foodQuantityName = cellData.price.name;
    billObj.finalprice = conversionPrice.finalPrice;
    billObj.note = "";
    billObj.priceIndex = 0;
    billObj.quantity = quantity;
    billObj.offerDenom = cellData.offertype;
    billObj.offerAmt = cellData.offerAmt;
    billObj.print = false;
    billObj.combo = (cellData.catgId === 'snp_combo_id');
    return billObj;
};

export const handleIncrement = (cellData, updateItems) => {
    printDebugLog("handleIncrement", cellData);
    let value = cellData.quantity;
    if (isNumberEmpty(value))
        value = 0;
    const quantity = Number(value) + 1;
    updateItems(cellData, quantity);
}

export const handleDecrement = (cellData, updateItems) => {
    let value = cellData.quantity;
    if (isNumberEmpty(value))
        value = 0;
    let quantity = Number(value) - 1;
    if (quantity < 0) //For Decimal Safety
        quantity = 0;
    updateItems(cellData, quantity);
};

export const getBillTypeName = (billType, token, tableNo, tableName) => {
    let data = "";

    switch (billType) {
        case InternalBillType.BookTable:
            data = `${!isEmpty(tableName) ? tableName + "/" : ""}Table no: ${tableNo}`;
            break;
        case InternalBillType.Home:
            data = "Home Delivery";
            break;
        case InternalBillType.TakeAway:
            data = "Take Away";
            break;
        default:
            break;
    }

    if (token > -1) {
        data += ` (Order No: ${token})`;
    }

    return data;
};

export const doTotal = (oldPrice = 0.0,
    billTotal = 0.0,
    mCgst = 0.0,
    mSgst = 0.0,
    loyalityPointDetails,
    mIgstAllowed = false, //Feature to check if gRpC is enabled
    mDelvCharge = 0.0,
    m_OfferDenom = OfferType.No_Offer,
    m_OfferAmt = 0.0,
    partilBillAvail,
    paymentDetails,
    setPaymentDetails = () => { },
    setLoyalityPointDetails = () => { },
    requiredPayMethodClear = true
) => {
    printDebugLog("doTotal =>", oldPrice, billTotal, mCgst, mSgst, mIgstAllowed, mDelvCharge, m_OfferDenom, m_OfferAmt);
    const parsedOldPrice = parseFloat(oldPrice) || 0.0;
    const parsedBillTotal = parseFloat(billTotal) || 0.0;
    let parsedPointRedeem = loyalityPointDetails.isPointAdded ? parseFloat(loyalityPointDetails.pointRedeem) || 0.0 : 0.0;
    const parsedDelvCharge = parseFloat(mDelvCharge) || 0.0;
    const parsedOfferAmt = parseFloat(m_OfferAmt) || 0.0;
    printDebugLog("doTotal =>", parsedOldPrice, parsedBillTotal, parsedPointRedeem, parsedDelvCharge, parsedOfferAmt);
    let mRoundOff = 0.0;
    const subTotal = parseFloat(paymentDetails.totalPrice) + parsedBillTotal - parsedOldPrice;
    let finalPrice = subTotal;
    switch (parseInt(m_OfferDenom)) {
        case OfferType.Flat:
            finalPrice -= parsedOfferAmt;
            break;
        case OfferType.Percentage:
            finalPrice -= (subTotal * parsedOfferAmt) / 100;
            break;
        default:
            break; // No offer
    }

    let cgstAmt = 0.0;
    let sgstAmt = 0.0;
    if (mIgstAllowed) {
        cgstAmt = (finalPrice * Number(mCgst)) / 100;
        sgstAmt = (finalPrice * Number(mSgst)) / 100;
    }

    if (parsedPointRedeem >= finalPrice) {
        parsedPointRedeem = finalPrice.toFixed(2);
        finalPrice = 0.0;
    } else {
        finalPrice += cgstAmt + sgstAmt - parsedPointRedeem + parsedDelvCharge;
        mRoundOff = finalPrice.toFixed() - finalPrice;
        finalPrice = finalPrice + mRoundOff;
    }

    printDebugLog("doTotal <=", finalPrice, subTotal, cgstAmt, sgstAmt, mRoundOff);
    const dues = partilBillAvail ? finalPrice : 0.0;
    setLoyalityPointDetails(prev => ({
        ...prev,
        isPointAdded: (parsedPointRedeem > 0.0),
    }))
    if (requiredPayMethodClear) {
        setPaymentDetails(prvs => ({
            ...prvs,
            totalPrice: uiUtilInstance.roundTo(subTotal, 2), //subtotal
            cgst: mCgst,
            sgst: mSgst,
            pendingAmt: uiUtilInstance.roundTo(dues, 2),
            cgstAmt: uiUtilInstance.roundTo(cgstAmt, 2),
            sgstAmt: uiUtilInstance.roundTo(sgstAmt, 2),
            isGstAllowed: mIgstAllowed,
            finalPrice: uiUtilInstance.roundTo(finalPrice, 2), //finalprice
            roundOff: uiUtilInstance.roundTo(mRoundOff, 2),
            takenDenom: m_OfferDenom,
            takenOffrAmt: m_OfferAmt,
            delvName: prvs.delvName,
            onlinePayMedium: "",
            onlinePayThrough: "",
            onlinePay: 0.0,
            cashPay: 0.0,
            cashPayThrough: "",
            cashReturn: 0.0,
            cashTender: 0.0,
            payMedium: PayMedium.NOPAY,
            delvCharge: parsedDelvCharge,
        }));
    } else {
        setPaymentDetails(prvs => ({
            ...prvs,
            totalPrice: uiUtilInstance.roundTo(subTotal, 2), //subtotal
            cgst: mCgst,
            sgst: mSgst,
            pendingAmt: uiUtilInstance.roundTo(dues, 2),
            cgstAmt: uiUtilInstance.roundTo(cgstAmt, 2),
            sgstAmt: uiUtilInstance.roundTo(sgstAmt, 2),
            isGstAllowed: mIgstAllowed,
            finalPrice: uiUtilInstance.roundTo(finalPrice, 2), //finalprice
            roundOff: uiUtilInstance.roundTo(mRoundOff, 2),
            takenDenom: m_OfferDenom,
            takenOffrAmt: m_OfferAmt,
            delvName: prvs.delvName,
            delvCharge: parsedDelvCharge,
        }));
    }

    printDebugLog("doTotal", finalPrice);
};

export const getPartialPayButtonName = (billStatus, duesAmt) => {
    let name = "";
    if (billStatus === BillStatus.PARTIALLYPAID) {
        name = "Clear Dues";
        if (duesAmt > 0)
            name = name + " (₹ " + duesAmt + ")";
    } else {
        name = "Partial Pay";
    }
    return name;
};

export const getDateTime = (createdAt) => {
    const today = new Date();
    const hours = today.getHours().length === 2 ? today.getHours() : `0${today.getHours()}`;
    const minutes = today.getMinutes().length === 2 ? today.getMinutes() : `0${today.getMinutes()}`;
    const seconds = today.getSeconds().length === 2 ? today.getSeconds() : `0${today.getSeconds()}`;
    const time = " " + hours + ":" + minutes + ":" + seconds;
    const finalDate = createdAt.includes(":") ? createdAt : `${createdAt}${time}`;
    return finalDate;
}

export const buildJconCustData = (customerData) => {
    const custData = {
        custId: customerData.custId,
        custMob: customerData.custMob,
        custEmail: customerData.custEmail,
        address: customerData.address,
        custName: customerData.custName,
        custGstDetails: customerData.custGstDetails,
        custCompanyName: customerData.custCompanyName,
    };
    return custData;
}

export const buildJsonPayDetails = (paymentDetails, isOthHomeDelv, delvNameOth) => {
    const payData = {
        payMedium: paymentDetails.payMedium,
        onlinePayThrough: paymentDetails.payMedium === PayMedium.CASH ? "" : paymentDetails.onlinePayThrough,
        onlinePayMedium: paymentDetails.payMedium === PayMedium.CASH ? "" : paymentDetails.onlinePayMedium,
        cashPayThrough: paymentDetails.payMedium === PayMedium.ONLINE ? "" : paymentDetails.cashPayThrough,
        onlinePay: Number(paymentDetails.onlinePay),
        cashPay: Number(paymentDetails.cashPay),
        cashTender: paymentDetails.payMedium === PayMedium.ONLINE ? 0.0 : Number(paymentDetails.cashTender),
        cashReturn: paymentDetails.payMedium === PayMedium.ONLINE ? 0.0 : Number(paymentDetails.cashReturn),
        roundOff: Number(paymentDetails.roundOff),
        cgst: Number(paymentDetails.cgst),
        sgst: Number(paymentDetails.sgst),
        cgstAmt: Number(paymentDetails.cgstAmt),
        sgstAmt: Number(paymentDetails.sgstAmt),
        isGstAllowed: paymentDetails.isGstAllowed,
        subTotal: Number(paymentDetails.totalPrice),
        total: Number(paymentDetails.finalPrice),
        takenDenom: Number(paymentDetails.takenDenom),
        takenOffrAmt: Number(paymentDetails.takenOffrAmt),
        delvName: isOthHomeDelv ? delvNameOth : paymentDetails.delvName,
        delvCharge: Number(paymentDetails.delvCharge),
    };
    return payData;
};

export const buildJsonInitialData = (columnList, shopHashId, billNo, isMobile, tableId, billType, bStatus, createdAt, tokenKey = "value") => {
    const initialData = {
        [tokenKey]: getAuthSession().apiToken,
        value_2: columnList,
        shopHash: shopHashId,
        billNo: billNo,
        tableId: tableId,
        isMobile: isMobile,
        billType: Number(billType),
        billStatus: bStatus,
        createdAt: getDateTime(createdAt),
    };
    return initialData;
};

export const buildJsonExternalData = (externalBillDetails) => {
    const externalData = {
        hotelBillId: externalBillDetails.hotelBillId,
        hotelBillNo: externalBillDetails.hotelBillNo,
        homeDelvId: externalBillDetails.homeDelvId,
        homeDelvOtp: externalBillDetails.homeDelvOtp,
    };
    return externalData;
}

export const kotJsonData = (columnList,
    shopHashId, billNo, tableId, isMobile, billType, isOthHomeDelv, delvNameOth, createdAt, bStatus, kotCopies,
    paymentDetails, customerData, externalBillDetails, tripDetails, coupon, appliedCoupon
) => {

    const jcJson = {
        ...buildJsonInitialData(columnList, shopHashId, billNo, isMobile, tableId, billType, bStatus, createdAt),
        ...buildJconCustData(customerData),
        ...buildJsonPayDetails(paymentDetails, isOthHomeDelv, delvNameOth),
        ...buildJsonExternalData(externalBillDetails),
        tripStatus: (isEmpty(tripDetails.tripStatus) || INITIATED === tripDetails.tripStatus) ? SEND_TO_KITCHEN : tripDetails.tripStatus,
        riderId: tripDetails.riderId,
        kotCopies: kotCopies,
        coupon: appliedCoupon ? coupon : "",
    };
    return jcJson;
};

export const payLaterJsonData = (columnList,
    shopHashId, billNo, tableId, isMobile, billType, isOthHomeDelv, delvNameOth, createdAt, bStatus, settleDown,
    loyalityPointDetails,
    paymentDetails, customerData, externalBillDetails, tokenKey = "value"
) => {

    const jcJson = {
        ...buildJsonInitialData(columnList, shopHashId, billNo, isMobile, tableId, billType, bStatus, createdAt, tokenKey),
        ...buildJconCustData(customerData),
        ...buildJsonPayDetails(paymentDetails, isOthHomeDelv, delvNameOth),
        ...buildJsonExternalData(externalBillDetails),
        pointRedeem: loyalityPointDetails.isPointAdded ? Number(loyalityPointDetails.pointRedeem) : 0.0,
        settleDown: settleDown,
    };
    return jcJson;
};

export const initiatePayJsonData = (columnList,
    shopHashId, billNo, tableId, isMobile, billType, isOthHomeDelv, delvNameOth, createdAt, isPartial,
    loyalityPointDetails,
    paymentDetails, customerData, externalBillDetails, partialPay, coupon, appliedCoupon
) => {
    const bStatus = isPartial ? BillStatus.PARTIALLYPAID : BillStatus.PAID;
    const settleDown = (billType === InternalBillType.BookTable) ? true : false;
    const jcJson = {
        ...payLaterJsonData(columnList,
            shopHashId, billNo, tableId, isMobile, billType, isOthHomeDelv, delvNameOth,
            createdAt, bStatus, settleDown, loyalityPointDetails,
            paymentDetails, customerData, externalBillDetails),
        isGenerateBill: false,
        partialBillAudit: isPartial ? partialPay : null,
        coupon: appliedCoupon ? coupon : "",
    };
    return jcJson;
};

export const generateInititalPayLinkBillJsonData = (columnList,
    shopHashId, billNo, tableId, isMobile, billType, isOthHomeDelv, delvNameOth, createdAt,
    loyalityPointDetails,
    paymentDetails, customerData, externalBillDetails, partialPay, coupon, appliedCoupon, tokenKey = "value"
) => {
    const settleDown = (billType === InternalBillType.BookTable) ? true : false;
    const jcJson = {
        ...payLaterJsonData(columnList,
            shopHashId, billNo, tableId, isMobile, billType, isOthHomeDelv, delvNameOth,
            createdAt, BillStatus.INITIATED, settleDown, loyalityPointDetails,
            paymentDetails, customerData, externalBillDetails, tokenKey),
        isGenerateBill: true,
        partialBillAudit: partialPay,
        coupon: appliedCoupon ? coupon : "",
    };
    return jcJson;
};


export const updateBillStatus = (billStatus, setBillStatus, setIsPaid) => {
    const kBillStatus = Number(billStatus);
    if (kBillStatus === BillStatus.CANCEL_BILL
        || kBillStatus === BillStatus.PAID
        || kBillStatus === BillStatus.PARTIALLYPAID
        || kBillStatus === BillStatus.HOMEDELIVERYINITIATED
        || kBillStatus === BillStatus.HOMEDELIVERYCASHPAY
        || kBillStatus === BillStatus.HOMEDELIVERYPAY) {
        setIsPaid(true);
    }
    setBillStatus(kBillStatus);
}
